$("#add-bundle-to-cart").on("click", function () {
    const selectedVariants = $("#SingleOptionSelector-0")
        .find(":selected")
        .data("sku");
    let products = selectedVariants.split("|");
    let items = [];
    for (product of products) {
        let productData = product.split(",");
        let variantId = productData[0];
        let sellingPlanId = productData[1];
        items.push({
            quantity: 1,
            id: variantId,
            selling_plan: sellingPlanId,
        });
    }

    jQuery.post("/cart/add.js", { items }).done(function (e) {
        window.location = "/cart";
    });
});

$(document).ready(function () {
    $(".choose").on("click", function () {
        $(".choose").removeClass("chosen");
        $(this).addClass("chosen");
    });

    $(".add-to-cart").on("click", function () {
        jQuery
            .post("/cart/add.js", {
                quantity: 1,
                id: $(".chosen").data("variant-id"),
            })
            .done(function (e) {
                window.location = "/cart";
            });
    });
});